'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var date = require('./date.js');
var dateTime = require('./dateTime.js');
var dateTimeWithYear = require('./dateTimeWithYear.js');
var dateTimeWithYearAndTimeZone = require('./dateTimeWithYearAndTimeZone.js');
var dateWithShortMonth = require('./dateWithShortMonth.js');
var monthDayYear = require('./monthDayYear.js');
var timestamp = require('./timestamp.js');

/**
 * Date Format List.
 */ const variants = {
    date: date.default,
    dateTime: dateTime.default,
    dateTimeWithYear: dateTimeWithYear.default,
    monthDayYear: monthDayYear.default,
    timestamp: timestamp.default,
    dateWithShortMonth: dateWithShortMonth.dateWithShortMonth,
    dateTimeWithYearAndTimeZone: dateTimeWithYearAndTimeZone.default
};

exports.default = variants;
//# sourceMappingURL=index.js.map
